/**
 * Default API Endpoint Prefix
 *
 * API Endpoints defined in the {@link tmrDefaultApiEndpoints}
 * constant and/or overridden with {@link TmrApi TmrApiProvider} use `tmrApiPrefix`
 * when they don't have a `prefix` key.
 *
 * `process.env.tmrEnv.tmrApiPrefix` takes precedence. It can be passed:
 * - By setting tmrApiPrefix in tmr-env.json
 * - By passing the env variable BACKEND_URL (see README.md)
 *
 * @namespace tmrApiPrefix
 * @type {ngConstant}
 */
export const constant = [
  'tmrApiPrefix',
  process.env.tmrEnv.tmrApiPrefix ?? 'tmr-api',
]
